module.exports = __webpack_public_path__ + "static/media/usdfi_icon.c64e2fe6.svg";